module.exports = __webpack_public_path__ + "img/04n-Shop_651.6bd438a7.jpg";